import { useAsync, useMountEffect } from "@react-hookz/web";
import { useAtomValue } from "jotai";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import {
  scmpArticleSpeechConfigAtom,
  type ScmpPwaArticleSpeechAppConfig,
} from "scmp-app/lib/article-speech/atoms";
import type { scmpArticleSpeechConfigQuery } from "scmp-app/queries/__generated__/scmpArticleSpeechConfigQuery.graphql";

export const useArticleSpeechConfig = () => {
  const environment = useRelayEnvironment();
  const configFromPageQuery = useAtomValue(scmpArticleSpeechConfigAtom);

  const [state, actions] = useAsync(
    async (): Promise<ScmpPwaArticleSpeechAppConfig | undefined> => {
      const data = await fetchQuery<scmpArticleSpeechConfigQuery>(
        environment,
        graphql`
          query scmpArticleSpeechConfigQuery {
            appConfig(filter: { entityId: "scmp_pwa_article_speech" }) {
              json
            }
          }
        `,
        {},
        {
          fetchPolicy: "network-only",
        },
      ).toPromise();

      if (!data?.appConfig?.json) return;
      return data.appConfig.json;
    },
  );

  useMountEffect(() => {
    // The article page provides the config through the page query instead. Surfaces without
    // that hydration (e.g. the Plus article popup opened on non-article pages) need this fetch.
    if (configFromPageQuery) return;

    void actions.execute();
  });

  return { scmpArticleSpeechConfigState: configFromPageQuery ?? state.result };
};
